import { ReactNode } from 'react';
import { css } from '@bts-web/utils-style-engine';
import { RegularInfo } from '../../../../common/svgIcons/RegularInfo';

interface InfoContentLayoutProps {
  title: string;
  children: ReactNode;
  actions?: ReactNode;
}

export const InfoContentLayout = ({
  title,
  children,
  actions,
}: InfoContentLayoutProps) => (
  <div
    className={css({
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 'medium',
      textAlign: 'center',
    })}
  >
    <RegularInfo size={48} color="information.fill_primary" />
    <p
      className={css({
        fontSize: 'headline.medium_medium',
        fontWeight: 'headline.medium_medium',
        lineHeight: 'headline.medium_medium',
        letterSpacing: 'headline.medium_medium',
        color: 'neutrals.text_primary',
      })}
    >
      {title}
    </p>
    {children}
    {actions}
  </div>
);

export const bodyTextStyles = css({
  color: 'neutrals.text_primary',
  fontSize: 'body.medium',
  lineHeight: 'body.medium',
});

export const bodyGroupStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'small',
  color: 'neutrals.text_primary',
  fontSize: 'body.medium',
  lineHeight: 'body.medium',
});
